import { createFileRoute } from "@tanstack/react-router";
import { preloadLazyModule } from "src/lib/LazyModules";
import { getDocsPage } from "src/server/functions/DocsPage";
import DocsPageView from "./-components/DocsPageView";
import { docsPageHead } from "./-components/docsPageHead";

// /docs (Quick start). Same page as /docs/$, for the content/docs/index.mdx page. Its moderation
// playground (ModerationPlaygroundDocs) is a lazy module, shown to visitors with a selected project
// (the layout's data, as PortalContext selects it): preloaded for them only.
export const Route = createFileRoute("/docs/")({
  loader: async ({ parentMatchPromise }) => {
    const [page] = await Promise.all([
      getDocsPage({ data: "" }),
      parentMatchPromise.then(({ loaderData }) =>
        loaderData?.authState?.user && loaderData.selectedProjectId
          ? preloadLazyModule("moderationPlayground")
          : undefined,
      ),
    ]);
    return page;
  },
  staleTime: Number.POSITIVE_INFINITY,
  head: docsPageHead,
  component: () => <DocsPageView data={Route.useLoaderData()} />,
});
